export default __webpack_public_path__ + "static/media/_ghiacco_secco_16mm.75832cc2.png";